import type { AppState, MealType, Recipe } from '../types';

function hasBeenTried(state: AppState, recipeId: string): boolean {
  for (const w of state.weeks) {
    for (const m of w.meals) {
      if (m.recipe_id === recipeId && m.rating !== null) return true;
    }
  }
  return false;
}

export function shouldNudgePickyEater(state: AppState, weekId: string): boolean {
  if (!state.settings.show_picky_eater_nudge) return false;
  const week = state.weeks.find(w => w.id === weekId);
  if (!week) return false;
  const planned = week.meals.filter(m => m.recipe_id);
  if (planned.length < 4) return false;
  if (!planned.every(m => m.rating === 'up')) return false;
  // No untried recipes in the week (every recipe has been tried before)
  for (const m of planned) {
    if (m.recipe_id && !hasBeenTried(state, m.recipe_id)) return false;
  }
  return true;
}

export function pickUntried(state: AppState, mealType: MealType): Recipe | null {
  const eligible = state.recipes.filter(r =>
    r.meal_types.includes(mealType) && r.status !== 'no'
  );
  // Maybe-tagged first, then never-rated, excluding ones tried before
  const maybes = eligible
    .filter(r => r.status === 'maybe' && !hasBeenTried(state, r.id))
    .sort((a, b) => a.name.localeCompare(b.name));
  if (maybes.length) return maybes[0]!;
  const neverTried = eligible
    .filter(r => r.status === null && !hasBeenTried(state, r.id))
    .sort((a, b) => a.name.localeCompare(b.name));
  return neverTried[0] ?? null;
}
